import React from "react";
import { Card, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import BlockColorCode from "../Devices/DevServices/BlockColorCode"

const ProjectCards = (props) => {
    const {all_projects} = props
//<span className="green-bullet me-2"></span> onlineContent(v.dev_online)
    return (
      <div className="container mt-1">
      <Row>
        {
          all_projects.map((v,i) => {
            return (
              <Col
              key={`proj_${i}`}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              xl={3}
            >
              <Card>
                <Card.Img style={{ height: "10rem", objectFit: "cover" }} className="img-thumbnail rounded mx-auto d-block" variant="top" src={v.image_path} />
                <Card.Body>
                  <Card.Title>
                    <div className="d-flex align-items-center">
                      {v.name}
                      <BlockColorCode
                        project_color_code={v.project_color_code}
                        dataName="project_color_code"
                      />
                    </div>
                  </Card.Title>
                  
                  <Card.Text>
                    {v.description}
                  </Card.Text>
                  <Link to={`/selected_project/${v.id}`}><Button variant="primary">Show me</Button></Link>

                </Card.Body>
              </Card>
            </Col>
            )
          })
        }
      </Row>
    </div>
    )

}

export default ProjectCards;

const onlineContent = (onlineObj) => {
  const out = []
  
/*   out.push(<span className="green-bullet me-2">3</span>)
  return <><span className="text-success">3</span>, <span className="text-danger">3</span>, <span className="text-warning">3</span></> 
 */
  if (onlineObj.online > 0) out.push(<span className="text-success">{onlineObj.online}</span>)
  if (onlineObj.offline > 0) out.push(<span className="text-danger">{onlineObj.offline}</span>)
  if (onlineObj.na > 0) out.push(<span className="text-warning">{onlineObj.na}</span>)
/*   out.push(<span className="text-success">3</span>)
  out.push(<span className="text-danger">3</span>)
  out.push(<span className="text-warning">3</span>) */
  return <span className="d-inline-flex"> 
              {out.map((v, i) => {
                if (i === 0) return <span key={i}>{v}</span>
                return <span key={i}>, {v}</span>
              })}
  </span>  

}